import React, { useEffect, useState } from 'react';
// ... остальные импорты остаются без изменений ...

function OrderHistory() {
  // ... остальной код остается без изменений ...

  return (
    <div className="min-h-screen bg-gray-50 pt-20"> {/* Изменен pt-20 */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* ... остальной код остается без изменений ... */}
      </div>
    </div>
  );
}

export default OrderHistory;